export default {
    listagem: {
        titulo_pagina: 'Classes Integration Helper',
        novo: 'Criar nova classe helper',
        table: {
            empty: 'Nenhuma classe helper encontrada',
            nome: 'Nome',
            classe: 'Classe',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar nova classe Helper',
            editar: 'Editar classe Helper'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome da classe helper'
            },
            classe: {
                label: 'Classe',
                description: 'Classe helper'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo'
            },
            botao_salvar : 'Salvar helper'
        },
        create: {
            success: 'Classe helper criada com Sucesso!',
            error: 'Error ao criar classe helper!'
        },
        update: {
            success: 'Classe helper editada com Sucesso!',
            error: 'Error ao editar classe helper!'
        }
    }
}
